<template>
  <v-app
    id="inspire"
    :class="[
      {
        'collapse-sidebar': collapseSidebar
      }
    ]"
  >
    <router-view></router-view>
    <video-ayuda
      v-bind="videoAyuda"
      v-on:cerrar="cerrarVideoAyuda"
    ></video-ayuda>
    <v-auditoria></v-auditoria>
    <notifications
      group="general"
      position="top right"
      animation-type="velocity"
    />
  </v-app>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import appConfig from '@/config/appConfig'
import VideoAyuda from '@/components/Video/VideoAyuda'
import VAuditoria from '@/components/Auditoria/VAuditoria'
// import Modelo from '@/api/app'
export default {
  components: {
    VideoAyuda, VAuditoria
  },
  data () {
    return {
      animation: {
        enter: {
          opacity: [1, 0],
          translateX: [0, -300],
          scale: [1, 0.2]
        },
        leave: {
          opacity: 0,
          height: 0
        }
      }
    }
  },
  created () {
    this.$vuetify.theme.primary = process.env.VUE_APP_VUETIFY_THEME_PRIMARY
    axios.get(appConfig.urlApi.concat('/app')).then(response => {
      this.$store.dispatch('setApp', response.data)
      this.$store.dispatch('videoAyuda/setVideos', response.data)
    })
  },
  computed: {
    ...mapGetters(['collapseSidebar']),
    videoAyuda () {
      return this.$store.getters['videoAyuda/data']
    }
  },
  methods: {
    cerrarVideoAyuda () {
      this.$store.dispatch('videoAyuda/cerrar')
    }
  }
}
</script>
<style lang="scss">
.tabla-azul .theme--light.v-table thead th {
  background-color: #e0e0e0;
  color: #2e3344;
}
.tabla-azul .v-datatable__actions {
  background-color: #e0e0e0 !important;
  color: #2e3344 !important;
}
.toolbar-azul
  .theme--dark
  .v-text-field
  > .v-input__control
  > .v-input__slot::before {
  border-color: #fafafa !important;
}
</style>
